import Countdown, { zeroPad } from "react-countdown";
import labels from "../../../config/labels";
import config from "../../../config";
import styles from "./PromotionTimer.module.scss";
const env = config.env;
const imagePrefix = config.envConfigs[env].imagePrefix;
const PromotionTimer = ({ date ,flag}) => {

  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <div className={styles.timerContainer}>
        <img src={`${imagePrefix}/assets/images/promotion-tag.svg`} />
        <span className={styles.discountLabel}>
          {labels.lbl_discount_end_text}:
        </span>

        {days > 0 ? <span className={styles.time}><span className={styles.zerotimepad}>{flag ? zeroPad(days).replace(/^0+/, ''): zeroPad(days) }</span><span>d</span> </span> :
        <span className={styles.zerotime}><span className={styles.zerotimepad}>0</span><span>d</span></span>}
        {(hours) ?
          <span className={styles.time}><span className={styles.zerotimepad}>{flag ? zeroPad(hours).replace(/^0+/, ''): zeroPad(hours) }</span><span>h</span></span>
        :  <span className={styles.zerotime}><span className={styles.zerotimepad}>0</span><span>h</span></span>}
        {(minutes) ?
          <span className={styles.time}><span className={styles.zerotimepad}>{flag ? zeroPad(minutes).replace(/^0+/, ''): zeroPad(minutes) }</span><span>m</span> </span>
        :  <span className={styles.zerotime}><span className={styles.zerotimepad}>0</span><span>m</span></span>}
        {seconds > 0 && (
          <span className={styles.zerotime}><span className={styles.zerotimepad}>{flag ? zeroPad(seconds).replace(/^0+/, ''): zeroPad(seconds) }</span><span>s</span></span>
        )}
      </div>
    );
  };
  return (
    <>
      <Countdown date={date} renderer={renderer} zeroPadTime={1} />
    </>
  );
};
export default PromotionTimer;
